export const primary = {
  50: '#fff6fd',
  100: '#ffeef9',
  150: '#fee6f6',
  200: '#fddef2',
  250: '#fbd4ef',
  300: '#f9c9eb',
  350: '#f7bfe9',
  400: '#f4b5e6',
  450: '#ef96da',
  500: '#e975cc',
  550: '#e150be',
  600: '#d912ae',
  650: '#bb0c94',
  700: '#9d067b',
  750: '#810264',
  800: '#65004d',
  850: '#4d003a',
  900: '#370028',
  950: '#220017',
}
export const accent = {
  50: '#fffaf6',
  100: '#fff6ee',
  150: '#fef1e7',
  200: '#fdeddf',
  250: '#fee5ce',
  300: '#ffddbd',
  350: '#ffd6ab',
  400: '#ffce99',
  450: '#fdb678',
  500: '#fb9d58',
  550: '#f78139',
  600: '#f3631b',
  650: '#db5115',
  700: '#c33f0e',
  750: '#ab2e06',
  800: '#941b00',
  850: '#730f00',
  900: '#530400',
  950: '#350000',
}
export const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  150: '#f0f0f0',
  200: '#ebebeb',
  250: '#e3e5e6',
  300: '#dcdfe0',
  350: '#d4d9db',
  400: '#cdd3d6',
  450: '#aab0b4',
  500: '#888f92',
  550: '#686f72',
  600: '#495054',
  650: '#3f4549',
  700: '#353b3f',
  750: '#2b3135',
  800: '#22272b',
  850: '#181c1f',
  900: '#0e1113',
  950: '#050709',
}
